var _defs, _g, _path, _path2, _path3, _polygon, _rect, _polyline, _path4, _path5, _path6, _rect2, _rect3, _rect4, _path7, _rect5, _rect6, _rect7, _circle, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUniversities(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0aadd6;}.cls-2{fill:none;stroke:#2f2d3b;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.cls-3{fill:#e6e7e8;}.cls-4{fill:#2992cc;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 15,
    y: 52,
    width: 11,
    height: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M45,24v26c0,1.1-.9,2-2,2h-5v4h11V24h-4Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M6,56H58c1.1,0,2,.9,2,2v1H4v-1c0-1.1,.9-2,2-2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M4,21H60v1c0,1.1-.9,2-2,2H6c-1.1,0-2-.9-2-2v-1h0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M32,2L2,12v6H62v-6L32,2Zm0,11c-1.66,0-3-1.34-3-3s1.34-3,3-3,3,1.34,3,3-1.34,3-3,3Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "2 12 32 2 62 12 62 18 2 18 2 12"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 9,
    y: 24,
    width: 6,
    height: 32
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "55 43 55 56 49 56 49 24 55 24 55 39"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M27,62H60v-4c0-1.1-.9-2-2-2H6c-1.1,0-2,.9-2,2v4H23"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22,24H58c1.1,0,2-.9,2-2v-4H4v4c0,1.1,.9,2,2,2h12"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M32,40c-3.31,0-6,2.69-6,6v10h6v-16Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 19,
    y: 29,
    width: 3,
    height: 6
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 29,
    y: 29,
    width: 3,
    height: 6
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 39,
    y: 29,
    width: 3,
    height: 6
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M32,40h0c3.31,0,6,2.69,6,6v10h-12v-10c0-3.31,2.69-6,6-6Z"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 19,
    y: 29,
    width: 6,
    height: 6
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 29,
    y: 29,
    width: 6,
    height: 6
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 39,
    y: 29,
    width: 6,
    height: 6
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 32,
    cy: 10,
    r: 3
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 32,
    y1: 40,
    x2: 32,
    y2: 56
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniversities);
export default __webpack_public_path__ + "static/media/universities.65f8382f03295d080b26abcdafdcbb2b.svg";
export { ForwardRef as ReactComponent };